import { FunctionComponent } from 'react';

export interface DetailItem {
  url: string;
  title: string;
  name:string;
  category: string;
  animalRaw: boolean;
  type: number;
}

interface FilteredItemListProps {
  items: DetailItem[];
  type: number;
  noFilteredHitsText: string;
}

const FilteredItemList: FunctionComponent<FilteredItemListProps> = ({ items, type, noFilteredHitsText }) => {
  if (!items) return null;

  return (
    <>
      {items.length === 0 && (
        <p dangerouslySetInnerHTML={{ __html: noFilteredHitsText }}></p>
      )}
      <div aria-live="polite">
        {items.map((item, idx) => (
          <div key={idx} className={`list-item ${type === 0 ? 'three-columns' : 'two-columns'}`}>
            {type === 0 && (
              <>
                <span className="e-number">{item.title}</span>
                <a className="name" href={item.url}>{item.name}</a>
              </>
            )}
            {type === 2 && (
              <a className="name" href={item.url}>{item.title}</a>
            )}
            <span className="category-label">{item.category}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default FilteredItemList;